function CheveronSelectionIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className="icon-cheveron-selection" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M8.7 9.7a1 1 0 11-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 11-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 011.4 1.4l-4 4a1 1 0 01-1.4 0l-4-4a1 1 0 011.4-1.4l3.3 3.29 3.3-3.3z"
        className="secondary"
      />
    </svg>
  );
}

export default CheveronSelectionIcon;
